// RecentAttendanceCard — the student dashboard's last-3-sessions card.
import { Link } from "react-router-dom";
import AttendanceStatusBadge from "../shared/AttendanceStatusBadge.js";
import { IconClipboardCheck } from "../shared/icons.js";
import { formatDate } from "../../lib/formatDateTime.js";
import type { AttendanceRecordWithSession } from "@dm-lms/shared/types";

interface RecentAttendanceCardProps {
  records: AttendanceRecordWithSession[];
  isLoading: boolean;
}

export default function RecentAttendanceCard({ records, isLoading }: RecentAttendanceCardProps) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-5">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-sm font-medium text-dm-navy">
          <IconClipboardCheck width={16} height={16} className="text-dm-slate" />
          Recent attendance
        </h2>
        <Link to="/app/student/attendance" className="text-xs font-medium text-dm-blue hover:underline">
          View all
        </Link>
      </div>

      {isLoading && <p className="text-sm text-dm-slate">Loading…</p>}

      {!isLoading && records.length === 0 && <p className="text-sm text-dm-slate">No sessions attended yet.</p>}

      {!isLoading && records.length > 0 && (
        <div className="divide-y divide-gray-100">
          {records.slice(0, 3).map((record) => (
            <div key={record.id} className="flex items-center justify-between gap-3 py-2">
              <p className="truncate text-sm text-dm-navy">{record.sessionTitle}</p>
              <div className="flex shrink-0 items-center gap-3">
                <AttendanceStatusBadge status={record.status} />
                <span className="text-xs text-dm-slate">{formatDate(record.scheduledAt)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
